import { render, staticRenderFns } from "./CInfoAlert.vue?vue&type=template&id=ff442ca4&scoped=true"
import script from "./CInfoAlert.vue?vue&type=script&lang=ts"
export * from "./CInfoAlert.vue?vue&type=script&lang=ts"
import style0 from "./CInfoAlert.vue?vue&type=style&index=0&id=ff442ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff442ca4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
